<app-header></app-header>
<div class="wrapper" style="margin-top: 96px">
  <div class="section_wrapper">
    <div style="margin-bottom: 13px">
      <h1 class="font_40_a32 title" [ngClass]="{ noResults: historyState.address == null }">
        Get your free account
      </h1>
      <mat-error [ngClass]="{ noResults: historyState.address == null }">
        All fields are mandatory
      </mat-error>
    </div>
    <div class="login_screen">
      <div class="form_left_section">
        <form class="" [formGroup]="form">
          <p *ngIf="isDuplicateAccount" style="color: red">
            * Account with same email id exits
          </p>
          <div class="name_box">
            <div class="w-100">
              <mat-form-field class="genericTextFiled w_100">
                <mat-label>First Name</mat-label>
                <input #firstName matInput placeholder="Firstname" formControlName="firstname" required
                  (keydown.enter)="transferFocus($event, lastName)" />
              </mat-form-field>
              <mat-error class="error-message" *ngIf="form.get('firstname').hasError('required') && submitted">
                please enter your first name
              </mat-error>
            </div>
            <div class="w-100">
              <mat-form-field class="genericTextFiled w_100">
                <mat-label>Last Name</mat-label>
                <input (keydown.enter)="transferFocus($event, email)" #lastName matInput placeholder="Lastname"
                  formControlName="lastname" />
              </mat-form-field>
              <mat-error class="error-message" *ngIf="form.get('lastname').hasError('required') && submitted">
                please enter your last name
              </mat-error>
            </div>
          </div>

          <div class="w-100">
            <mat-form-field class="genericTextFiled w_100">
              <mat-label>Email</mat-label>
              <input #email type="email" (keydown.enter)="transferFocus($event, phone)" matInput placeholder=""
                name="email" formControlName="email" required autocomplete="off" />
            </mat-form-field>
            <mat-error *ngIf="
              form.get('email').hasError('required') 
                 &&
              submitted
            ">please enter a valid email address</mat-error>
          </div>

          <div class="w-100">
            <mat-form-field class="genericTextFiled w_100">
              <mat-label>Phone</mat-label>
              <input #phone matInput type="phone" (keydown.enter)="transferFocus($event, password)"
                placeholder="(xxx) xxx-xxxx" name="phone" formControlName="phone" required appPhoneFormattor />
            </mat-form-field>
            <!-- <mat-error
            *ngIf="(form.get('phone').hasError('required') || form.get('phone').hasError('pattern'))&& submitted">Please
            enter a
            valid phone number</mat-error> -->
            <mat-error *ngIf="form.get('phone').hasError('required') && submitted">please enter your phone
              number</mat-error>
          </div>

          <div class="w-100">
            <mat-form-field class="genericTextFiled w_100">
              <mat-label>Password</mat-label>
              <input #password matInput autocomplete="off" [type]="hide ? 'password' : 'text'" placeholder=""
                name="password" required formControlName="password" />
              <app-icon-button *ngIf="hide" matSuffix [margin]="'0 5px 0 0'" (click)="changepasswordIcon()">
                <img src="../../../assets/icons/show_eyes_icon.svg" alt="" />
              </app-icon-button>
              <app-icon-button *ngIf="!hide" matSuffix [margin]="'0 5px 0 0'" (click)="changepasswordIcon()">
                <img *ngIf="!hide" src=" ../../../assets/icons/hide_eye_icon.svg" alt="" />
              </app-icon-button>
            </mat-form-field>
            <!-- <mat-error
              *ngIf="(form.get('password').hasError('required') || form.get('password').hasError('pattern'))&& submitted">
              Password must contain

              <div>
                <li>Minimum 8 characters</li>
                <li>Atleast one lowercase letter</li>
                <li>Atleast one uppercase letter</li>
                <li>Atleast one number</li>
                <li>Atleast one special character </li>
              </div>
            </mat-error>
          </div>
          <app-green-button-v2 class="create_button" *ngIf="!isLoader" label="Create free account" [width]="'218px'"
            [height]="'60px'">
            <img class="after" src="../../../assets/icons/arrow_white.svg" alt="arrow_white" style="margin-left: 10px;">
          </app-green-button-v2>
          <app-loader *ngIf="isLoader" style="margin-left: auto;"></app-loader>
          <p class=" login_text" style="font-weight: 500;">
            Already have an account?
            <button class="login_btn" (click)="login()">
              Login
            </button>
          </mat-form-field> -->
            <mat-error *ngIf="
                (form.get('password').hasError('required') ||
                  form.get('password').hasError('pattern')) &&
                submitted
              ">
              please enter a password
              <!-- <div>
                <li>Minimum 8 characters</li>
                <li>Atleast one lowercase letter</li>
                <li>Atleast one uppercase letter</li>
                <li>Atleast one number</li>
                <li>Atleast one special character </li>
              </div> -->
            </mat-error>
          </div>
          <div class="w-100">
            <mat-checkbox color="secondary" formControlName="smsConfirmation">
              <p>I agree to receive text messages at the number provided. Message and data rates may apply <br>
                <a href="https://homerise.com/sms-terms-conditions/" target="_blank">Terms and Conditions</a>.
              </p>
            </mat-checkbox>
            <mat-error class="error-message" *ngIf="(submitted && form.get('smsConfirmation').value != true)">please
              confirm
            </mat-error>
          </div>
          <div class="sign_up_buttons">
            <app-green-button-v2 [buttonType]="'submit'" (click)="onSubmit()" class="create_button" *ngIf="!isLoader"
              label="Create free account" [width]="'218px'" [height]="'60px'">
              <img class="after" src="../../../assets/icons/arrow_white.svg" alt="arrow_white"
                style="margin-left: 10px" />
            </app-green-button-v2>
            <app-loader *ngIf="isLoader"></app-loader>

            <app-outlined-green-button *ngIf="
                this.appState?.companyInfoValue?.awsCognitoConfig
                  ?.enableAppleSignIn
              " (click)="logInWithIDP('SignInWithApple')" label="Continue with Apple" [width]="'218px'"
              [height]="'60px'" [styles]="{ borderColor: '#d4d4d4' }">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="before">
                <path
                  d="M18.52 8.23c-.1.09-2 1.18-2 3.62 0 2.82 2.4 3.82 2.48 3.84-.01.06-.38 1.37-1.27 2.7-.78 1.17-1.6 2.34-2.86 2.34-1.25 0-1.58-.75-3.02-.75-1.41 0-1.91.77-3.06.77-1.15 0-1.95-1.08-2.86-2.41A11.9 11.9 0 0 1 4 12.04C4 8.36 6.33 6.4 8.62 6.4c1.22 0 2.23.82 3 .82.73 0 1.86-.87 3.25-.87.52 0 2.4.05 3.65 1.88zm-4.31-3.45c.57-.7.98-1.67.98-2.65 0-.13-.01-.27-.04-.38-.93.04-2.04.64-2.7 1.44a4.2 4.2 0 0 0-1.02 2.58c0 .15.02.3.03.34.06.01.16.03.25.03.84 0 1.9-.58 2.5-1.36z"
                  fill="#d5d5d5"></path>
              </svg>
            </app-outlined-green-button>

          </div>
          <p class="login_text" style="font-weight: 500">
            Already have an account?
            <button class="login_btn" (click)="login()">Login</button>
          </p>
        </form>
      </div>

      <div class="result_right_section" *ngIf="historyState != null && historyState.address != null">
        <div class="resluts">
          <img *ngIf="historyState.imgUrl != null" src="{{ historyState.imgUrl }}" />
          <img *ngIf="historyState.imgUrl == null" src="../../../assets/images/dummy_land.png" alt="" />

          <div class="result_box">
            <p class="font_24_a32_600 address_text" style="margin-bottom: 30px">
              {{ historyState.address }}
            </p>
            <!-- <div class="price_date d_flex">
              <p class="font_16_a32_700"> <span class="font_16_a32_500">SFR - List
                  Price</span><br>
                ${{listingPrice | number }}</p>
              <p class="font_16_a32_700" *ngIf="listingContractDate!=null"> <span class="font_16_a32_500"> Listed
                  On</span><br>
                {{listingContractDate | date}}</p>
              <p class="font_16_a32_700" *ngIf="listingContractDate==null"> <span class="font_16_a32_500"> Listed
                  On</span><br>
                -</p>
            </div> -->
            <div class="property_detail d_flex">
              <p class="font_16_a32_700">
                <span class="font_16_a32_500">Bedrooms</span><br />
                {{ bedroomsTotal }}
              </p>
              <p class="font_16_a32_700">
                <span class="font_16_a32_500"> Baths</span><br />
                {{ bathroomsDecimal }}
              </p>
              <p class="font_16_a32_700" *ngIf="livingArea != null">
                <span class="font_16_a32_500">SqFt </span><br />
                {{ livingArea | number }}
              </p>
              <p class="font_16_a32_700" *ngIf="livingArea == null">
                <span class="font_16_a32_500">SqFt </span><br />
                {{ livingArea | number }}
              </p>
              <p class="font_16_a32_700" *ngIf="lotSizeSquareFeet != null">
                <span class="font_16_a32_500"> Sq Ft Lot </span><br />
                {{ lotSizeSquareFeet | number }}
              </p>
              <p class="font_16_a32_700" *ngIf="lotSizeSquareFeet == null">
                <span class="font_16_a32_500"> Sq Ft Lot </span><br />
                -
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>